import { client } from '@repo/api-kit/queries/utils';

import { apiBaseURL } from 'register-partners-js/constants/hosts';
import { waitForFetch } from 'register-partners-js/utils/wait-for-fetch';

client.init({
  baseURL: apiBaseURL,
  fetch: (...args) => waitForFetch(fetch(...args)),
});
